module.exports = __webpack_public_path__ + "img/remark_en.e3adf9ec.png";